import script from "./ControlPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ControlPanel.vue?vue&type=style&index=0&id=e86bff70&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e86bff70"]])

export default __exports__